import React from "react";
import { i18n } from "@euroland/libs";
import { formatDate } from "@euroland/libs";
import { TOOL_TEMPLATE } from "../constant/common";
import { useTemplateSetting } from "../hooks/useCompanySettings";
import { classNames, replaceKey } from "../utils";
import { renderTextBasedOnTemplate } from "../store/utils";
import { useInstrument } from "../hooks/useInstruments";

function SingleTicker({ data = {} }) {
  const template = useTemplateSetting();
  const isQuadrata = template === TOOL_TEMPLATE.quadrata;
  // const isVictor = template === TOOL_TEMPLATE.victor;
  // const isVictor = template === TOOL_TEMPLATE.victor;
  const [{ isIpo }] = useInstrument();

  return (
    <section
      className={classNames("singleTicker", {
        quadrata: isQuadrata,
      })}
      tabIndex={0}
    >
      <h2 className="singleTicker__name">{data.ticker}</h2>
      {
       !isIpo && <p className="singleTicker__date">
        {renderTextBasedOnTemplate(
          replaceKey(i18n.translate("startingDateTickerQuadrata"), [
            formatDate(data.startingDate, "shortDate"),
          ]),
          replaceKey(i18n.translate("dateSingleTickerVictor"), [formatDate(data.startingDate, "shortDate")])
        )}
      </p>
      }
    </section>

  );
}

export default SingleTicker;
